import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from './propertyQueryKeys'
import { getProperty } from './propertyEndpoints'
import { parsePropertyDetail } from './propertyParser'

// Detail of one property. `id` comes from the route param (reactive) — the query
// only fires once an id is present and refetches if it changes.
//
// The whole options object is the getter (rather than `queryKey: () => ...`):
// this version of @tanstack/vue-query types `queryKey` as MaybeRefDeep, which a
// getter does not satisfy, but accepts a getter for the options as a whole. Same
// reactivity, and it type-checks.
export function usePropertyQuery(id: MaybeRefOrGetter<string>) {
  return useQuery(() => ({
    queryKey: propertyKeys.detail(toValue(id)),
    queryFn: () => getProperty(toValue(id)).then(parsePropertyDetail),
    enabled: Boolean(toValue(id)),
  }))
}
